import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { first } from 'rxjs/operators';
import { AuthenticationService } from 'src/app/Services/Authentication/authentication.service';
import { UserRole } from 'src/app/Model/Role/user-role.model'

@Component({
  selector: 'app-external-login',
  templateUrl: './external-login.component.html',
  styleUrls: ['./external-login.component.css']
})
export class ExternalLoginComponent implements OnInit {

  loginForm: FormGroup;
  loading = false;
  returnUrl: string;
  submitted = false;
  error;

  
  constructor( private fb: FormBuilder,
    private route: ActivatedRoute,
    private router: Router,
    private authenticationService: AuthenticationService) { }

  ngOnInit(): void {


    this.loginForm = this.fb.group({
      username: ['', Validators.required],
      password: ['', Validators.required]
  });

  this.route.queryParams.subscribe(params => {
    console.log(params);
    // This is never executed, for route is not recognized
    // let myArray=params.getAll('extra');
    const username = params['extra'];
    const password = params['extra1'];
    console.log(username);
    if (username) {
     // console.log(fullName);
      this.onSubmit(username, password);
      //this. getSalesRep(branch);
    //  this.viewMode = true;
    } else {
      //this.viewMode = false;
     // console.log('done');
    }
  });


  // get return url from route parameters or default to '/'
  this.returnUrl = this.route.snapshot.queryParams['returnUrl'] || '/main-dashboard';
  }

  
  
  // convenience getter for easy access to form fields
  get f() { return this.loginForm.controls; }

  onSubmit(username,password) {
    this.submitted = true;

    // stop here if form is invalid
   // if (this.loginForm.invalid) {
     //   return;
    //}

    this.loading = true;
    this.authenticationService.login(username, password)
        .pipe(first())
        .subscribe(
            data => {
              this.router.navigate([this.returnUrl]);
         this.redirectUser(data.role);
            },
            error => {
                this.error = error;
                this.loading = false;
            });
}




redirectUser(userRole) {
  if (userRole == UserRole.Administrator) {
    this.router.navigate(['/main-dashboard']);
  } else if (userRole == UserRole.Employee) {
      this.router.navigate(['../employee-details', { extra: this.authenticationService.currentUserValue.userName, extra1:this.authenticationService.currentUserValue.firstName, extra2:this.authenticationService.currentUserValue.lastName }], { relativeTo: this.route });
  } else if (userRole == UserRole.SystemAdministrator) {
    this.router.navigate(['/main-dashboard'])
  }else if (userRole == UserRole.Management) {
    this.router.navigate(['/main-dashboard'])
  }else if (userRole == UserRole.Receptionist) {
    this.router.navigate(['/main-dashboard'])
  }else if (userRole == UserRole.SalesRepresentative) {
    this.router.navigate(['/sales-rep-home'])
  }else if (userRole == UserRole.SalesSupport) {
    this.router.navigate(['/sales-rep-home'])
  }else if (userRole == UserRole.User) {
    this.router.navigate(['/main-dashboard'])
  }else if (userRole == UserRole.Manager) {
    this.router.navigate(['/main-dashboard'])
  }else if (userRole == UserRole.Reporter) {
    this.router.navigate(['/main-dashboard'])
  }else if (userRole == UserRole.Shipper) {
    this.router.navigate(['/logistics-main'])
  }

}


}
